import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { DialogModule } from '@sb/library/dialog';
import { ElevioModule } from '@sb/library/elevio';
import { FormFieldModule } from '@sb/library/form-field';
import { LayoutModule } from '@sb/library/layout';
import { SubmissionBarModule } from '@sb/library/submission-bar';
import { UploadModule } from '@sb/library/upload';
import { UtilityModule } from '@sb/library/utility';
import { ProfileButtonComponent } from './profile-button/profile-button.component';
import { ProfileImageComponent } from './profile-image.component';
import { ProfileMenuButtonComponent } from './profile-menu-button/profile-menu-button.component';
import { ProfileImageUploadDialogComponent } from './upload-dialog/profile-image-upload-dialog.component';


@NgModule({
    declarations: [
        ProfileImageComponent,
        ProfileImageUploadDialogComponent,
        ProfileButtonComponent,
        ProfileMenuButtonComponent
    ],
    imports: [
        CommonModule,
        UtilityModule,
        ButtonModule,
        DialogModule,
        MatTooltipModule,
        UploadModule,
        LayoutModule,
        FormFieldModule,
        ReactiveFormsModule,
        ElevioModule,
        SubmissionBarModule,
        BaseModule
    ],
    exports:[
        ProfileImageComponent,
        ProfileImageUploadDialogComponent,
        ProfileButtonComponent,
        ProfileMenuButtonComponent
    ]
})
export class ProfileImageModule { }
